<template>
    <div id="classify">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">分类</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>
        <div class="fl">
            <div :class="{active : active == 2}" @click="active=2"><p>女生</p></div>
            <div :class="{active : active == 1}" @click="active=1"><p>男生</p></div>
        </div>
        <div class="fr">
            <ul>
                <router-link v-for="item in getList" :to="{name:'Classifybook',params:{cid:item.id}}" tag="li">
                    <img :src="'http://static.yuread.cn/' + item.cover + '@!thumb'" alt="" >
                    <p>{{item.title}}</p>
                </router-link>

            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Classify",
        data(){
            return {
                active : 2,
                male : [],
                female : [],
            }
        },computed :{
            getList(){
                if(this.active == 2){
                    return this.female;
                }else{
                    return this.male;
                }
            }
        }
        ,methods : {
            getClassifyList(){
                this.axios.post("/api/classify/getClassifyList").then(r=>{
                    this.male = r.data.data[1];
                    this.female = r.data.data[2];
                })
            }
        },created(){
            this.getClassifyList();
        }
    }
</script>

<style lang="less">
    #classify{background: #f6f6f7;overflow: hidden;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .fl{width:146px;
            div{width:100%;height:145px;padding: 45px 0;text-align: center;font-size: 30px;}
            div.active{background: #fff;
                p{border-left: 5px solid @theme;color: @theme;}
            }
        }
        .fr{width:calc(100% - 146px);min-height: 500px;background: #fff;
            ul{padding: 80px 40px;
                li{width:250px;float: left;margin-bottom: 80px;
                    img{width:72px;height: 96px;float: left;box-shadow: 0 1px 3px rgba(0,0,0,.3);}
                    p{padding: 30px 0;text-indent: 20px;font-size: 28px;}
                }
            }
        }
    }
</style>
